import { ReadMore } from 'react-shorten';
import React from 'react';
import Button from "react-bootstrap/Button";

export const ReadMoreContainer = ({
                                    truncate,
                                    showMoreText,
                                    showLessText,
                                    className,
                                    style,
                                    children,
                                  }) => {
  const [expanded, setExpanded] = React.useState(false);

  const onShowMore = React.useCallback(() => setExpanded(true), []);

  const onShowLess = React.useCallback(() => setExpanded(false), []);

  return (
    <ReadMore
      truncate={truncate}
      expanded={expanded}
      showMore={
        <>
          {'... '}
          <Button
            variant={"outline-dark"}
            onClick={onShowMore}
            className={className}
            style={style}
          >
            {showMoreText ?? 'Show more'}
          </Button>
        </>
      }
      showLess={
        <>
          {' '}
          <Button
            variant={"outline-dark"}
            onClick={onShowLess}
            className={className}
            style={style}
          >
            {showLessText ?? 'Show less'}
          </Button>
        </>
      }
    >
      {children}
    </ReadMore>
  );
};

export default ReadMoreContainer;